import React from "react";
import {Badge} from "peggirkit";
import {useIntl} from "react-intl";
import {useTooltip} from "@widgets/tooltip/TooltipProvider";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";

const UnreadContactFormsBadge = () => {
    const intl = useIntl();
    const {applyTooltip} = useTooltip();
    const {dashboardStatus: {openJobApplicationsCount}} = useRestaurant();

    return (
        <Badge
            color={openJobApplicationsCount === 0 ? "secondary" : "success"}
            props={{
                ...applyTooltip(intl.formatMessage({id: "nOpenJobApplications"}, {n: openJobApplicationsCount})),
            }}
            role={"status"}
            aria-label={intl.formatMessage({id: "openJobApplications"})}
        >
            {openJobApplicationsCount}
        </Badge>
    );
};

export default UnreadContactFormsBadge;